export default "__VITE_ASSET__C6jjVR_L__"